/** @flow */

import {
  GetEapList,
  GetEapListSuccess,
  GetEapListError,
  SetEapEnabled,
  GetEap,
  GetEapSuccess,
  GetEapError,
  GetEapSchema,
  GetEapSchemaSuccess,
  GetEapSchemaError,
  NewEap,
  DuplicateEapSuccess,
  SetEapDraft,
  NewEapAssignments,
  SetEapAssignments,
  StartDraftEapSuccess,
  ShowAddModal,
  ShowEditModal,
  ShowEditAssignmentsModal,
  SetShowDiscardEapModal,
  SetShowSubmitEapModal,
  SetShowDisableEapModal,
  SetShowCancelEapModal,
  SetShowCancelDiscardEapModal,
  SetEapDraftAssignments,
} from "@modules/service/constants/actions";
import * as eapSignpostingReducers from "./reducers";
import initialState from "./state";
import type { EapState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: EapState = initialState, action: Object): EapState => {
  const act = {
    [GetEapList]: eapSignpostingReducers.onGetEapList,

    [SetEapEnabled]: eapSignpostingReducers.onSetEapEnabled,

    [GetEap]: eapSignpostingReducers.onGetEap,
    [GetEapSuccess]: eapSignpostingReducers.onGetEapSuccess,
    [GetEapError]: eapSignpostingReducers.onGetEapError,

    [GetEapSchema]: eapSignpostingReducers.onGetEapSchema,
    [GetEapSchemaSuccess]: eapSignpostingReducers.onGetEapSchemaSuccess,
    [GetEapSchemaError]: eapSignpostingReducers.onGetEapSchemaError,

    [GetEapListSuccess]: eapSignpostingReducers.onGetEapListSuccess,
    [GetEapListError]: eapSignpostingReducers.onGetEapListError,

    [NewEap]: eapSignpostingReducers.onNewEap,
    [DuplicateEapSuccess]: eapSignpostingReducers.onDuplicateEapSuccess,
    [StartDraftEapSuccess]: eapSignpostingReducers.onStartDraftEapSuccess,
    [SetEapDraft]: eapSignpostingReducers.setEapDraft,

    [NewEapAssignments]: eapSignpostingReducers.onNewEapAssignments,
    [SetEapAssignments]: eapSignpostingReducers.setEapAssignments,
    [SetEapDraftAssignments]: eapSignpostingReducers.onSetEapDraftAssignments,

    [ShowAddModal]: eapSignpostingReducers.onShowAddModal,
    [ShowEditModal]: eapSignpostingReducers.onShowEditModal,
    [ShowEditAssignmentsModal]: eapSignpostingReducers.onShowEditAssignmentsModal,
    [SetShowDiscardEapModal]: eapSignpostingReducers.onSetEapShowDiscardModal,
    [SetShowSubmitEapModal]: eapSignpostingReducers.onSetEapShowSubmitModal,
    [SetShowDisableEapModal]: eapSignpostingReducers.onSetEapShowDisableModal,
    [SetShowCancelEapModal]: eapSignpostingReducers.onSetEapShowCancelModal,
    [SetShowCancelEapModal]: eapSignpostingReducers.onSetEapShowCancelModal,
    [SetShowCancelDiscardEapModal]: eapSignpostingReducers.onSetEapShowCancelDiscardModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
